import { PlainModal } from '@/components/modals/plain-modal';

import styles from './styles.module.scss';
import type { Component } from './types';

export const RemarkModal: Component = ({
  isOpen,
  onClose,
  submodelFullName,
  piName,
  remark,
  remarkClassName,
}) => (
  <PlainModal
    className={`${styles.containerRemarkModal} `}
    contentClassName={`${remarkClassName}`}
    isOpen={isOpen}
    modalTitle={submodelFullName}
    onClose={onClose}>
    <div className={styles.textRemarkContent}>
      <div className={styles.textDealerName}>
        {piName}
      </div>
      {remark}
    </div>
  </PlainModal>
);
